<template>
  <vx-card v-if="report" no-shadow class="eodReportViewOnly">
    <h2 class="mb-6">General</h2>

    <h5 class="mb-6">When</h5>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Date (opening date)</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <code>{{ report.date | date }}</code>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Closing time</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <code>{{ report.closingTime }}</code>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Last guest out</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <code>{{ report.lastGuestOutTime }}</code>
      </div>
    </div>

    <vs-divider />

    <h5 class="mb-6">Answers</h5>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Events</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Any events held today"
          v-model="report.arrangement" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>General comments</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="General comments for the day"
          v-model="report.generalComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Staff comments</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Comments about the staff"
          v-model="report.personaleComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Marketing / Guest relations</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Comments about guest relations"
          v-model="report.guestRelationsComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Gimmicks / focus</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Should we focus on something?"
          v-model="report.focusComments" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>NightPay</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Any NightPay challenges?"
          v-model="report.nightpayComments" />
        <span>Rating: <b>{{ report.nightpayRating == 1 ? 'Yes' : 'No' }}</b></span>
      </div>
    </div>

    <vs-divider />

    <!-- <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Needs / Incidents <b>(Legacy)</b></span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea
          disabled
          height="120px"
          class="inputx w-full"
          label="Did anything break or do you need something?"
          v-model="report.defectsAndNeedsComments"
        />
        <vs-slider :min="0" :max="4" v-model="report.defectsPriority" disabled :color="priorityToColor(report.defectsPriority)" />
        <span>
          Priority: <b>{{ priorityToText(report.defectsPriority) }}</b></span
        >
      </div>
    </div> -->

    <!-- <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Security / Clientele <b>(Legacy)</b></span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-slider :min="1" :max="5" v-model="report.safetyRating" disabled />
        <span
          >Rating: <b>{{ ratingToText(report.safetyRating) }}</b></span
        >
      </div>
    </div> -->

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Needs</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Did you need something?"
          v-model="report.needsComments" />
        <!-- <vs-slider
          :min="0"
          :max="4"
          v-model="report.needsPriority"
          disabled
          :color="priorityToColor(report.needsPriority)"
        />
        <span>
          Priority: <b>{{ priorityToText(report.needsPriority) }}</b></span
        > -->
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Incidents</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="Did something happen or did anything break?"
          v-model="report.incidentsComments" />
        <vs-slider :min="0" :max="4" v-model="report.incidentsPriority" disabled
          :color="priorityToColor(report.incidentsPriority)" />
        <span>
          Priority: <b>{{ priorityToText(report.incidentsPriority) }}</b></span>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Music</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-slider :min="1" :max="5" v-model="report.musicRating" disabled />
        <span>Rating: <b>{{ musicScoreText }}</b></span>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Security</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="How was the security?"
          v-model="report.securityComments" />
        <vs-slider :min="1" :max="5" v-model="report.securityRating" disabled />
        <span>
          Rating: <b>{{ ratingToText(report.securityRating) }}</b></span>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Clientele</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea disabled height="120px" class="inputx w-full" label="How was the clientele?"
          v-model="report.clienteleComments" />
        <vs-slider :min="1" :max="5" v-model="report.clienteleRating" disabled />
        <span>
          Priority: <b>{{ ratingToText(report.clienteleRating) }}</b></span>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Photo(s) of the facade</h5>
        <vs-row>
          <img class="ml-3 mt-2 mb-2 rounded-lg shadow" v-for="(photo, index) in report.imageUrls" :key="index"
            :src="photo" height="240" v-img:photoAnswers />
        </vs-row>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Numbers</h5>
        <p>Numbers from PowerBI.</p>

        <vs-row>
          <img v-if="report.eodReportNumbersImage" class="ml-3 mt-2 mb-2 rounded-lg shadow"
            :src="report.eodReportNumbersImage" height="240" v-img:photoAnswers />
        </vs-row>
      </div>
    </div>
  </vx-card>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {},

  data() {
    return {
      reportId: ""
    };
  },
  computed: {
    ...mapGetters({
      report: "eodReports/eodReport"
    }),
    musicScoreText() {
      switch (this.report.musicRating) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Awesome";
        default:
          return "Not rated";
      }
    }
  },
  methods: {
    priorityToColor(priority) {
      switch (priority) {
        case 0:
          return "grey";
        case 1:
          return "#28C76F";
        case 2:
          return "#FF9F43";
        case 3:
          return "#FF4444";
        case 4:
          return "#FF1111";
        default:
          return "grey";
      }
    },
    ratingToText(rating) {
      switch (rating) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Perfect";
        default:
          return "Not rated";
      }
    },
    priorityToText(priority) {
      switch (priority) {
        case 0:
          return "None";
        case 1:
          return "Low";
        case 2:
          return "Medium";
        case 3:
          return "High";
        case 4:
          return "Very High";
        default:
          return "None";
      }
    }
  },
  async created() {
    this.reportId = this.$route.params.id;
    this.$vs.loading();
    await this.$store.dispatch("eodReports/getEodReport", this.reportId);
    console.log("Got report", this.report);
    this.$vs.loading.close();
  }
};
</script>

<style lang="scss">
.eodReportViewOnly {
  .inputx textarea {
    height: calc(100% - 20px);
  }
}
</style>
